<template>
    <table cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif;" class="q-ma-lg">
        <colgroup width="25"></colgroup>
        <colgroup width="73"></colgroup>
        <colgroup width="197"></colgroup>
        <colgroup width="42"></colgroup>
        <colgroup width="55"></colgroup>
        <colgroup width="84"></colgroup>
        <colgroup width="82"></colgroup>
        <tr>
            <td style="border-top: 1px solid #000000; border-left: 1px solid #000000" height="14" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000" align="left"><br></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="23"
                align="center"><b><font size=4>Factura nr. {{ bill.number }}</font></b></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="23"
                align="center"><b><font size=4>{{ bill.created_at }}</font></b></td>
        </tr>
        <tr>
            <td style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 height="33" align="left" valign=top><b><font size=2>Destinatar:</font></b></td>
            <td style="border-top: 1px solid #000000" colspan=4 align="left" valign=middle>
                <font size=2>
                  Denumirea companiei: <b>{{ requisites.name_in_signature }}</b>
                    <br>
                  Cod IBAN: <b>{{ requisites.checking_account }}</b>
                    <br>
                  Denumirea băncii: <b>{{ requisites.bank_name }}</b>
                    <br>
                  Denumirea băncii: <b>PBANUA2X</b>
                    <br>
                  Adresa companiei: <b>{{ requisites.address }}</b>
                </font>
            </td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=top><font
                size=2><br></font></td>
        </tr>
        <tr v-if="requisites.additional_info">
            <td style="border-left: 1px solid #000000" height="16" align="left"><br></td>
            <td style="border-right: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000;" align="left" colspan=2>
                <b><font size=2>{{ requisites.additional_info }}</font></b>
            </td>
            <!--      <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left"><br></td>-->
            <td style="border-top: 1px solid #000000;" align="left"><br></td>
            <td style="border-top: 1px solid #000000;" align="left"><br></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000"
                align="left"><br></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000; border-top: 1px solid #000000;"
                colspan=2 height="16"
                align="left" valign=top><b><font size=2>Plătitor:</font></b></td>
            <td style="border-right: 1px solid #000000; border-top: 1px solid #000000;" colspan=5 align="left"
                valign=middle>
                <font size=2>
                    <span>
                        Denumirea companiei: <b>{{ receiver ? receiver : 'Private person' }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.edrpou">
                        Cod fiscal: <b>{{ userRequisites.edrpou }} </b>
                        <br>
                    </span>
                    <span v-if="userRequisites.inn">
                        Cod TVA: <b>{{ userRequisites.inn }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.iban">
                        Cod IBAN: <b>{{ userRequisites.iban }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.legal_address">
                        Adresa companiei: <b>{{ userRequisites.legal_address }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.actual_address">
                        Adresa companiei: <b>{{ userRequisites.actual_address }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.full_name">
                        <b>
                            {{
                                userRequisites.user_position
                                    ? `${userRequisites.user_position} ${userRequisites.full_name}`
                                    : userRequisites.full_name
                            }}
                        </b>
                        <br>
                    </span>
                </font></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000; border-top: 1px solid #000000;"
                colspan=2 height="16"
                align="left" valign=middle><b><font size=2>Cod de serviciu:</font></b></td>
            <td style="border-right: 1px solid #000000; border-top: 1px solid #000000;" colspan=5 align="left"
                valign=middle>
                <font size=2>
                    {{ bill.project.service_code }}
                </font></td>
        </tr>
        <tr>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="32" align="center" valign=middle><b><font size=2>#</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 align="center" valign=middle><b><font size=2>Denumirea serviciilor</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center"><b><font size=2>Valută</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center" valign=middle><b><font size=2>Cantitate</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center" valign=middle><b><font size=2>Preț (fără TVA)</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center" valign=middle><b><font size=2>Suma fără TVA</font></b></td>
        </tr>
        <tr>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="46" align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 align="left" valign=top><font size=2>{{ bill.destination }}</font>
            </td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="left" valign=top><font size=2>{{ bill.service.service.unit }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.amount / 100).toFixed(2) }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.amount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr v-if="bill.paid_amount > 0 && bill.paid_amount < bill.amount">
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="46" align="right" valign=top sdval="1" sdnum="1033;"><font size=2>2</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 align="left" valign=top><font size=2>Deja plătit</font>
            </td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="left" valign=top><font size=2>{{ bill.service.service.unit }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.paid_amount / 100).toFixed(2) }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.paid_amount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right"><b><font size=2>Suma totală:</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                size=2>{{ (finalAmount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right"><b><font size=2>Suma TVA:</font></b></td>

            <td v-if="isNDSPayer && new Date(this.bill.true_created_at) > new Date('2020-01-31 23:59:00')"
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                size=2>Fără TVA*</font>
            </td>
            <td v-else
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                size=2>Fără TVA</font>
            </td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <td v-if="isNDSPayer && new Date(this.bill.true_created_at) > new Date('2020-01-31 23:59:00')"
            align="left" colspan=6 valign=top><b><i><font size=2>
            {{ requisites.custom_data }}
            <br></font></i></b>
        </td>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left" colspan=6 valign=top><b><i><font size=2><br>Suma totală: {{
                    Math.floor(finalAmount / 100)
                }}
                lei {{ finalAmount % 100 }} bani, fără TVA </font></i></b></td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td colspan=5 align="left" style="position: relative;">
                <font size=2>Emis de __________________ /{{ requisites.name_in_signature }}/</font>
                <img v-if="requisites.stamp_img_url" :src="requisites.stamp_img_url" alt="" class="stamp">
            </td>
        </tr>
        <td align="left" colspan=6 valign=top><b><i><font size=2>
            <br>Atenție! Vă rugăm să vă asigurați că specificați numărul facturii {{ bill.number }} în referința de plată.
        </font></i></b>
        </td>
    </table>
</template>

<script>
export default {
    name: 'DataGrid',

    props: {
        bill: {
            type: Object,
            required: true,
        },

        requisites: {
            type: Object,
            required: true,
        },

        userRequisites: {
            type: Object,
            required: true,
        },

        ndsData: {
            type: Object,
            required: true,
        },
    },

    computed: {
        receiver () {
          if (!this.userRequisites.company_name && this.bill.status === 'PAID') {
            return null
          }

          return this.userRequisites.company_name
            ? this.userRequisites.company_name
            : this.bill.project.payment_data?.company_name
        },

        finalAmount () {
            return (this.bill.paid_amount < this.bill.amount)
                ? this.bill.amount - this.bill.paid_amount
                : this.bill.amount
        },

        isNDSPayer () {
            return this.ndsData.ndsPayer === 1
        },
    },
}
</script>

<style scoped>
.stamp {
    position: absolute;
    z-index: -1;
    width: 200px;
    height: auto;
    left: 80px;
    top: -47px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Invoice/md/DataGrid.vue